import { Box, styled, Typography } from "@mui/material";
import React from "react";

const TermsAndConditions = ({ modal = false }) => {
  const Heading = styled(Typography)(({ theme }) => ({
    fontSize: modal ? "28px" : "32px",
    fontFamily: "Montserrat",
    fontWeight: 700,
    lineHeight: "40px",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: modal ? "16px !important" : "18px !important",
    },
  }));

  const Subheading = styled(Typography)(({ theme }) => ({
    fontSize: modal ? "14px" : "16px",
    fontFamily: "Montserrat",
    fontWeight: 600,
    lineHeight: modal ? "18px" : "22px",
    textAlign: "justify",
    padding: "8px 0",
    [theme.breakpoints.down("sm")]: {
      fontSize: modal ? "12px !important" : "14px !important",
    },
  }));

  const Para = styled(Typography)(({ theme }) => ({
    fontSize: modal ? "12px" : "14px",
    fontFamily: "Montserrat",
    fontWeight: 500,
    lineHeight: modal ? "18px" : "22px",
    textAlign: "justify",
    margin: modal ? "4px 0" : "8px 0",
    marginLeft: "36px",
    [theme.breakpoints.down("sm")]: {
      fontSize: modal ? "10px !important" : "12px !important",
      marginLeft: "16px",
    },
  }));

  return (
    <Box sx={{ bgcolor: modal ? "#FFFFFF" : "#F7F7F7" }}>
      <Box
        sx={{
          mx: { xs: 0, md: 5 },
          bgcolor: "#FFFFFF",
          px: { xs: 5, md: 5 },
          py: { xs: 6, md: 3 },
        }}
      >
        <Heading>General Terms and Conditions</Heading>

        <Para sx={{ fontWeight: 500, pt: 1, fontSize: { xs: "14px", md: "16px" } }}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod
          tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
          veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
          commodo consequat.
        </Para>

        <Subheading>I. Terms and Conditions</Subheading>
        <Para>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
          tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
          veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
          commodo consequat.
        </Para>
        <Para>
          Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
          dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
          proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        </Para>

        <Subheading>II. Product Information</Subheading>
        <Para>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque non
          purus vitae lorem varius placerat. Integer et erat eget risus gravida
          vehicula at a sapien. Cras interdum, augue in iaculis posuere, erat
          justo dignissim massa, sit amet malesuada turpis purus non sem.
        </Para>

        <Subheading>III. Order and Payment</Subheading>
        <Para>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id
          hendrerit sapien, sed cursus lorem. Nunc nec mi at velit dictum
          facilisis. Mauris ultricies porta diam, vel tincidunt mi feugiat non.
        </Para>
        <Para>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus porta
          lacus nec orci pulvinar, id porta mi posuere. Sed at magna ac sem
          euismod cursus non in est.
        </Para>

        <Subheading>IV. Delivery and Support</Subheading>
        <Para>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vitae
          neque vitae risus gravida lacinia. Pellentesque habitant morbi tristique
          senectus et netus et malesuada fames ac turpis egestas.
        </Para>

        <Subheading>V. Limitation and Liability</Subheading>
        <Para>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin sit amet
          ultricies erat. Integer ut arcu luctus, consequat ligula ut, ultrices
          eros. Nulla facilisi. Integer et augue a odio fermentum luctus.
        </Para>

        <Subheading>VI. Miscellaneous</Subheading>
        <Para>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer vel
          diam lacinia, iaculis tellus ac, ultrices libero. Suspendisse bibendum
          dui id metus pulvinar, id tincidunt augue vulputate.
        </Para>
      </Box>
    </Box>
  );
};

export default TermsAndConditions;
